import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    userId: Number
  }

  connect() {
    this.updateVisibility()
  }

  updateVisibility() {
    const currentUserId = this.getCurrentUserId()
    const statusElement = this.element.querySelector(".message-delivery-status")
    
    if (statusElement && currentUserId === this.userIdValue) {
      statusElement.classList.remove("d-none")
    }
  }

  toggleActions(event) {
    // Don't toggle if clicking on an actual action button or link
    if (event.target.closest('.btn-glass-action') || event.target.closest('.dropdown-menu')) {
      return
    }

    const isSelected = this.element.classList.contains("is-selected")
    
    // Close all other message actions first
    document.querySelectorAll(".message-row.is-selected").forEach(el => {
      el.classList.remove("is-selected")
    })

    // If it wasn't selected, select it now
    if (!isSelected) {
      this.element.classList.add("is-selected")
    }
  }

  showActions() {
    if (window.innerWidth > 768) {
      this.element.classList.add("is-selected")
    }
  }

  hideActions() {
    if (window.innerWidth > 768) {
      // Don't hide if a dropdown is open
      if (this.element.querySelector('.dropdown-menu.show')) return
      this.element.classList.remove("is-selected")
    }
  }

  getCurrentUserId() {
    const metaTag = document.querySelector('meta[name="current-user-id"]')
    return metaTag ? parseInt(metaTag.content) : null
  }
}
